var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-content-center w-100"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t(_vm.fieldLocalizationKey))+":")]),_c('p',{staticClass:"before-value"},[_vm._v(_vm._s(_vm.change.before))]),_c('p',{class:[_vm.variantClass, {
      'mr-auto': _vm.alignLeft
    }]},[_vm._v(" "+_vm._s(_vm.$t('Notifications.ToValue', { value: _vm.change.after.toString() }))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }